/**
 * Loss values arrive from the source as percentages (`0.02` means 0.02%). The number is
 * formatted on its own and the `%` supplied separately, so the unit can be set apart from
 * the value — and so each locale places the sign itself.
 */
export const PERCENT_VALUE_FORMAT: Intl.NumberFormatOptions = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

export const JITTER_FORMAT: Intl.NumberFormatOptions = {
  maximumFractionDigits: 1,
};

/**
 * Client-leg (mediaserver → browser) verdict thresholds. They mirror the source verdict in
 * mediaserver `RelayMonitorService.DetermineHealthStatus`, so one figure means the same on
 * both legs. Change them together.
 */
export const CLIENT_PACKET_LOSS_DEGRADED_PERCENT = 1;
export const CLIENT_PACKET_LOSS_CRITICAL_PERCENT = 5;
export const CLIENT_JITTER_DEGRADED_MS = 15;
export const CLIENT_JITTER_CRITICAL_MS = 25;

/**
 * Source figures older than this get a caution note. Camera-control polls every 30 s but only
 * pushes on change, so two missed polls is the earliest point an age means anything.
 */
export const SOURCE_STATUS_STALE_AFTER_MS = 60_000;

/**
 * Keyframe requests (PLI) per stats window that put the client leg at Caution. A PLI means the
 * decoder could not recover, so the viewer saw a broken or frozen picture; a healthy stream sends
 * none. No Alarm level from PLIs yet.
 */
export const CLIENT_PLI_DEGRADED_COUNT = 1;

/** How often the browser's WebRTC stats are read. */
export const CLIENT_STATS_POLL_INTERVAL_MS = 2_000;

/**
 * Client counters are not sampled for this long (three polls) after the connection comes up. Stream start
 * brings a burst of keyframe requests (PLI) and NACKs while the decoder waits for its first
 * keyframe; that is setup, not a link problem. A profile switch does not show the burst.
 */
export const CLIENT_STATS_START_GRACE_MS = 3 * CLIENT_STATS_POLL_INTERVAL_MS;

/** Client loss, NACK and PLI figures are read over this window, matching the source's 60 s window. */
export const CLIENT_STATS_WINDOW_MS = 60_000;
